import React from 'react';
import { ToggleButton, ToggleButtonProps } from '@placer-ui/components';
import { Controller, useFormContext } from 'react-hook-form';
import { ControllerProps, FieldValues } from 'react-hook-form/dist/types';

export type ControlledToggleButtonProps<T extends FieldValues = FieldValues> = Omit<
    ControllerProps<T>,
    'render'
> &
    Omit<ToggleButtonProps, 'value' | 'onChange'>;

export function ControlledToggleButton<T extends FieldValues = FieldValues>(
    props: ControlledToggleButtonProps<T>,
) {
    const formContext = useFormContext<T>();
    const {
        name,
        control = formContext.control,
        defaultValue,
        rules,
        disabled,
        shouldUnregister,
        ...inputProps
    } = props;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={rules}
            disabled={disabled}
            shouldUnregister={shouldUnregister}
            render={({ field }) => <ToggleButton {...inputProps} {...field} />}
        />
    );
}
